// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  font-family: 'Oswald', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222;


}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
*{
 padding: 0;
 margin: 0;
 outline: none;
 border: none;
 box-sizing: border-box;
}



:root {
  --black:#0e0e0e;
  --gray:#A0A0A0;
  --lgray:#dfdddd;
  --white:#FFFFFF;
  --red: #dc3545;
  --green: #0d7830;

  /* --primary_color:#B3B3B3; */
  /* --primary_color:#03e1c0; */
  --primary_color:#343434;
  --hover_primary_color: #B3B3B3;
  --secondary_color:#f6f6f6;
  --light_gray:#f6f6f6;
  --box_shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  --border_radius:50px;
  --border_color:#A0A0A0;

}
html{
  scroll-behavior: smooth ;
}

a {
  text-decoration: none;
  cursor: pointer;
  color: inherit;
  
}
table {
  width: 100%;
  border-collapse: collapse;
  overflow-x: auto;
}


th, td {
    padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ul {
  /* list-style:circle; */
}
button{
  cursor: pointer;
}

img{
  width: 100%;
  object-fit: cover;
  display: block;
}

p {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.6;
  text-transform: none;
}

h1{
  font-size: 8rem;
  font-weight: 600;
  line-height: 8rem;
  text-transform: none;
 }

h2{
  font-size: 4rem;
  font-weight: 100;
  line-height: 1.2;
  text-transform: none;
 }

 h3{
  
  font-size: 2.8rem;
  font-weight: 400;
  line-height: 1.3;
  text-transform: none;
 }
 h4{
  font-size: 2.1rem;
  font-weight: 400;
  line-height: 1.4;
  text-transform: none;
 }
h5{
  font-style: normal;
font-weight: 400;
font-size: 1.25rem;
line-height: 1.5rem;
}

h6{
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.5;
}
label{
  font-weight: bold;
}
.tooltipClass{
  display: flex;
  gap: .5rem;
  align-items: start;
  justify-content: flex-start;
}

select{
  width: 100%;
  height: 100%;
  outline: none;
  border-bottom: 1px solid var(--border_color);
  padding: 0.7rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.375rem;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input{
  width: 100%;
  /* height: 100%; */
  outline: none;
  border-bottom: 1px solid var(--border_color);
  padding: 0.7rem 1rem;
}
input:focus{
border: 1px solid var(--border_color);
border-radius: 4px;



}
input[type="color"] {
	/* -webkit-appearance: none;
	border: none;
	width: 32px;
	height: 32px; */

}
input[type="color"]::-webkit-color-swatch-wrapper {
	/* padding: 0; */
}
input[type="color"]::-webkit-color-swatch {
	/* border: none;
  border-radius: 8px; */

}
input[type="file"]::file-selector-button {
  background-color: var(--black);
  color: var(--white);
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
textarea{
  width: 100%;
  height: 100%;
  outline: none;
border-bottom: 1px solid var(--border_color);


  padding: 0.7rem;
}
textarea:focus{
  border: 1px solid var(--border_color);
  border-radius: 4px;


}

button{
  background:none;
  outline: none;
  border: none;
}


.btn{
  padding: 0.4rem 1rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: var(--primary_color);
  color: var(--white);
  border: 2px solid var(--primary_color);
  outline: none;
  cursor: pointer;
  line-height: 1.5;
  border-radius: var(--border_radius);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  &:hover{
    background-color: var(--secondary_color);
    color: var(--black) !important;
    border: 2px solid var(--primary_color);
  }
}



.icon_react{
  font-size: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.icon_react_big{
  font-size: 2rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

}


.secondary_btn{
  padding: 0.4rem 1rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: transparent;
  color: var(--primary_color);
  border: 2px solid var(--primary_color);
  outline: none;
  cursor: pointer;
  line-height: 1.5;
  border-radius: var(--border_radius);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  &:hover{
    background-color: var(--primary_color);
    color: var(--white) !important;
    border: 2px solid var(--secondary_color);
  }
}

.tertiary_btn{
  padding: 0.4rem 2rem;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--black) !important;
  background-color: var(--white);
  border: 2px solid var(--black);
  outline: none;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  border-radius: var(--border_radius);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;

}

.add_btn{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin-top: 2rem; */
}

.link_btn{
  text-decoration: underline;
  color: var(--primary_color);
  font-size: 1.1rem;
}

.active_btn{
  font-size: 1.1rem;
}

.submit_btn{
  outline: 1px solid var(--primary_color);
  outline-offset: 3px;
  animation: submit_btn 0.5s infinite linear;
}

.iBtn{
  color: var(--red);
  font-size: 1rem;
}

.editLink {
  cursor: pointer;
  color: var(--primary_color);
}

.deleteButton {
  cursor: pointer;
  color: var(--red);
}

.crossIcon{
  color: var(--gray);
}

.tickIcon{
  color: var(--green);
  font-size: 1.5rem;
}


.editLink:hover,
.deleteButton:hover {
  transform: scale(1.4); 
}


/* .deleteButton:hover {
  transform: scale(1.4); 
} */

@keyframes submit_btn {
  from{
    outline-offset: 0px;
  }
  to{
    outline-offset: 3px;

  }
}

.disabled_btn{
  padding: 0.4rem 2rem;
  width: -moz-fit-content;
  width: fit-content;
  color: var(--gray) !important;
  background-color: var(--light_gray);
  border: 2px solid var(--light_gray);
  outline: none;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  border-radius: var(--border_radius);
  -webkit-user-select: none;
          user-select: none;


}
.border{
  height: 15rem;
  width: 1rem;
  background-color: black;
  align-self: center;
  border-radius: 5px;
}

.border_horizontal{
  height: 1rem;
  width: 15rem;
  border-radius: 5px;
  background-color: black;
  align-self: center;
}
.borderless{
  border: none !important;

}
.box_shadow{
  box-shadow: var(--box_shadow);
  padding: 1rem;
}
.button_container_flex{
  display: flex;
  align-items: center;
  gap:1rem;
}

.blur_bg{
  background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(5px);
-webkit-backdrop-filter: blur(5px);
border: 1px solid rgba(255, 255, 255, 0.3);
}

.site_padding{
  padding: 5rem;
}
/* flex classes */
.flex_row_space_between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
 
.flex_row_center{
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.flex_row{
  display: flex;
}
.flex_column{
  display: flex;
  flex-direction: column;
}

.flex_row_center_center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex_column_center_center{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex_row_JustifyLeft_AlignCenter{
  display: flex;
  justify-content: left;
  align-items: center;
}

.flex_column_gap{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.flex_row_gap{
  display: flex;
  gap: 1rem;
}

.flexWrap{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flexWrapChild{
  width: 50%;
  padding: 1rem;
}


.back_button{
 display: none;
 cursor: pointer;
 
}
.back_button_visible{
  display: block;
  font-size: 2rem;
  position: absolute;
  left: 5rem;
  top: 10rem;
  z-index: 2;
  color: var(--black);
  cursor: pointer;
}
.back_button_hidden{
  display: none;

}
/* componenet common classes satrt here */

/* spinner Animation */
.spinnerAnimation{
  -webkit-animation-name: spin;
  -webkit-animation-duration: 400ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: spin;
  -moz-animation-duration: 400ms;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  -ms-animation-name: spin;
  -ms-animation-duration: 400ms;
  -ms-animation-iteration-count: infinite;
  -ms-animation-timing-function: linear;
  -o-transition: rotate(3600deg);
}
@keyframes spin {
  from {transform:rotate(0deg);}
  to {transform:rotate(360deg);}
}


.RefreshData{
  width: 12rem;
}

.dot{
  width: 5px;
  height: 5px;
  min-width: 5px;
  min-height: 5px;
  border-radius: 50%;
  background-color: var(--gray);
}

/* chart classes */
.chart_row {
  display: flex;
  /* gap: 2rem; */
  width: 100%;
  gap: 2rem;

}
.chart_box {
  position: relative;
  height: 22rem;
  box-shadow: var(--box_shadow);
  border-radius: 15px;
  padding: 1rem 2rem;
  background-color: var(--db_Bg);
  width: 50%;
}


.chart_row_with_cards{
  position: relative;
  display: flex;
  /* height: 28rem; */
  box-shadow: var(--box_shadow);
  border-radius: 15px;
  padding: 1rem 2rem;
  background-color: var(--db_Bg);
  width: 50%;
}

.chart_box_with_cards{
  width: 65%;
  /* height: 28rem; */
}


@media screen and (max-width: 1000px){

  .chart_box {
      position: relative;
      width: 100% !important;
  }

  .chart_row {
    flex-direction: column;
}
.chart_row_with_cards{
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.chart_box_with_cards{
  width: 100%;
}
}

@media screen and (max-width: 950px){

  h1 {
      font-size: 4.5rem;
      line-height: 1.2;
  }
  h2{
    font-size: 2.65rem;
   }
  
   h4{
    font-size: 1.5rem;
    line-height: 1.4;
    text-transform: none;
   }
  h5{
    font-style: normal;
  font-size: 1.25rem;
  line-height: 1.5rem;
  }
  
  
  
  .btn{
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    border: 1px solid var(--primary_color);
    font-weight: 500;
    line-height: 1;
  }

  



  .secondary_btn{
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    border: 1px solid var(--primary_color);
    font-weight: 500;
    line-height: 1;
  }
    
 
.tertiary_btn{
  padding: 0.82rem 2.1rem;
  font-size: 0.875rem;

}

  .site_padding{
    padding: 4rem 2rem 2rem 2rem;
  }
  .border{
    height: 0.2rem;
    width: 15rem;
  }
  }

@media screen and (max-width: 900px){
  .back_button{
    display: block;
    font-size: 2rem;
    position: absolute;
    left: 20px;
    top: 40px;
    z-index: 2;
    color: var(--black);
  }
  .back_button_visible{
    display: block;
    font-size: 2rem;
    position: absolute;
    left: 20px;
    top: 40px;
    z-index: 2;
    color: var(--black);
  }
  
}
@media screen and (max-width: 350px){
  .button_container_flex{
    gap: 0.5rem;
  }
  
.tertiary_btn{

padding: 0.4rem 2rem;

}
}

@media screen and (max-width: 350px){
  .button_container_flex{
  flex-direction: column;
  }}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;;cAEY;EACZ,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;;;AAGb;;AAEA;EACE;aACW;AACb;AACA;CACC,UAAU;CACV,SAAS;CACT,aAAa;CACb,YAAY;CACZ,sBAAsB;AACvB;;;;AAIA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;;EAEhB,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,mDAAmD;EACnD,oBAAoB;EACpB,sBAAsB;;AAExB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;;AAEhB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;IACI,YAAY;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;CACrB;;CAEA;;EAEC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;CACrB;CACA;EACC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,kBAAkB;AACpB,gBAAgB;AAChB,kBAAkB;AAClB,mBAAmB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;AACA,qCAAqC;AACrC,kBAAkB;;;;AAIlB;AACA;CACC;;;gBAGe;;AAEhB;AACA;CACC,gBAAgB;AACjB;AACA;CACC;uBACsB;;AAEvB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf,4CAA4C;;;EAG1C,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,kBAAkB;;;AAGpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;;AAGA;EACE,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB;IACE,wCAAwC;IACxC,8BAA8B;IAC9B,sCAAsC;EACxC;AACF;;;;AAIA;EACE,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;AAEnB;;;AAGA;EACE,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,wCAAwC;EAC1C;AACF;;AAEA;EACE,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;;EAEE,qBAAqB;AACvB;;;AAGA;;GAEG;;AAEH;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;;EAErB;AACF;;AAEA;EACE,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,mCAAmC;EACnC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;;;AAGnB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;AACtC,mBAAmB;AACnB,yCAAyC;AACzC,0BAA0B;AAC1B,kCAAkC;AAClC,0CAA0C;AAC1C;;AAEA;EACE,aAAa;AACf;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;;AAGA;CACC,aAAa;CACb,eAAe;;AAEhB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;;AAEf;AACA,yCAAyC;;AAEzC,sBAAsB;AACtB;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,2CAA2C;EAC3C,yCAAyC;EACzC,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;EACtC,wBAAwB;EACxB,6BAA6B;EAC7B,uCAAuC;EACvC,qCAAqC;EACrC,8BAA8B;AAChC;AAUA;EACE,MAAM,sBAAsB,CAAC;EAC7B,IAAI,wBAAwB,CAAC;AAC/B;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;;AAEX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;;AAGA;;EAEE;MACI,kBAAkB;MAClB,sBAAsB;EAC1B;;EAEA;IACE,sBAAsB;AAC1B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;;AAEA;;EAEE;MACI,iBAAiB;MACjB,gBAAgB;EACpB;EACA;IACE,kBAAkB;GACnB;;GAEA;IACC,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;GACrB;EACD;IACE,kBAAkB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB;;;;EAIA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;EAChB;;;;;;EAMA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;EAChB;;;AAGF;EACE,uBAAuB;EACvB,mBAAmB;;AAErB;;EAEE;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;;AAEF;EACE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;;AAEF;AACA;EACE;IACE,WAAW;EACb;;AAEF;;AAEA,oBAAoB;;AAEpB;AACA;;AAEA;EACE;EACA,sBAAsB;EACtB,CAAC","sourcesContent":["body {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  font-family: 'Oswald', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #222;\n\n\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n*{\n padding: 0;\n margin: 0;\n outline: none;\n border: none;\n box-sizing: border-box;\n}\n\n\n\n:root {\n  --black:#0e0e0e;\n  --gray:#A0A0A0;\n  --lgray:#dfdddd;\n  --white:#FFFFFF;\n  --red: #dc3545;\n  --green: #0d7830;\n\n  /* --primary_color:#B3B3B3; */\n  /* --primary_color:#03e1c0; */\n  --primary_color:#343434;\n  --hover_primary_color: #B3B3B3;\n  --secondary_color:#f6f6f6;\n  --light_gray:#f6f6f6;\n  --box_shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  --border_radius:50px;\n  --border_color:#A0A0A0;\n\n}\nhtml{\n  scroll-behavior: smooth ;\n}\n\na {\n  text-decoration: none;\n  cursor: pointer;\n  color: inherit;\n  \n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  overflow-x: auto;\n}\n\n\nth, td {\n    padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nul {\n  /* list-style:circle; */\n}\nbutton{\n  cursor: pointer;\n}\n\nimg{\n  width: 100%;\n  object-fit: cover;\n  display: block;\n}\n\np {\n  font-size: 1rem;\n  font-weight: 300;\n  line-height: 1.6;\n  text-transform: none;\n}\n\nh1{\n  font-size: 8rem;\n  font-weight: 600;\n  line-height: 8rem;\n  text-transform: none;\n }\n\nh2{\n  font-size: 4rem;\n  font-weight: 100;\n  line-height: 1.2;\n  text-transform: none;\n }\n\n h3{\n  \n  font-size: 2.8rem;\n  font-weight: 400;\n  line-height: 1.3;\n  text-transform: none;\n }\n h4{\n  font-size: 2.1rem;\n  font-weight: 400;\n  line-height: 1.4;\n  text-transform: none;\n }\nh5{\n  font-style: normal;\nfont-weight: 400;\nfont-size: 1.25rem;\nline-height: 1.5rem;\n}\n\nh6{\n  font-size: 1.1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\nlabel{\n  font-weight: bold;\n}\n.tooltipClass{\n  display: flex;\n  gap: .5rem;\n  align-items: start;\n  justify-content: flex-start;\n}\n\nselect{\n  width: 100%;\n  height: 100%;\n  outline: none;\n  border-bottom: 1px solid var(--border_color);\n  padding: 0.7rem 1rem;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.375rem;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\ninput{\n  width: 100%;\n  /* height: 100%; */\n  outline: none;\n  border-bottom: 1px solid var(--border_color);\n  padding: 0.7rem 1rem;\n}\ninput:focus{\nborder: 1px solid var(--border_color);\nborder-radius: 4px;\n\n\n\n}\ninput[type=\"color\"] {\n\t/* -webkit-appearance: none;\n\tborder: none;\n\twidth: 32px;\n\theight: 32px; */\n\n}\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n\t/* padding: 0; */\n}\ninput[type=\"color\"]::-webkit-color-swatch {\n\t/* border: none;\n  border-radius: 8px; */\n\n}\ninput[type=\"file\"]::file-selector-button {\n  background-color: var(--black);\n  color: var(--white);\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\ntextarea{\n  width: 100%;\n  height: 100%;\n  outline: none;\nborder-bottom: 1px solid var(--border_color);\n\n\n  padding: 0.7rem;\n}\ntextarea:focus{\n  border: 1px solid var(--border_color);\n  border-radius: 4px;\n\n\n}\n\nbutton{\n  background:none;\n  outline: none;\n  border: none;\n}\n\n\n.btn{\n  padding: 0.4rem 1rem;\n  width: fit-content;\n  background-color: var(--primary_color);\n  color: var(--white);\n  border: 2px solid var(--primary_color);\n  outline: none;\n  cursor: pointer;\n  line-height: 1.5;\n  border-radius: var(--border_radius);\n  user-select: none;\n  white-space: nowrap;\n  &:hover{\n    background-color: var(--secondary_color);\n    color: var(--black) !important;\n    border: 2px solid var(--primary_color);\n  }\n}\n\n\n\n.icon_react{\n  font-size: 1rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.icon_react_big{\n  font-size: 2rem;\n  cursor: pointer;\n  user-select: none;\n\n}\n\n\n.secondary_btn{\n  padding: 0.4rem 1rem;\n  width: fit-content;\n  background-color: transparent;\n  color: var(--primary_color);\n  border: 2px solid var(--primary_color);\n  outline: none;\n  cursor: pointer;\n  line-height: 1.5;\n  border-radius: var(--border_radius);\n  user-select: none;\n  white-space: nowrap;\n  &:hover{\n    background-color: var(--primary_color);\n    color: var(--white) !important;\n    border: 2px solid var(--secondary_color);\n  }\n}\n\n.tertiary_btn{\n  padding: 0.4rem 2rem;\n  width: fit-content;\n  color: var(--black) !important;\n  background-color: var(--white);\n  border: 2px solid var(--black);\n  outline: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  border-radius: var(--border_radius);\n  user-select: none;\n  white-space: nowrap;\n\n}\n\n.add_btn{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  /* margin-top: 2rem; */\n}\n\n.link_btn{\n  text-decoration: underline;\n  color: var(--primary_color);\n  font-size: 1.1rem;\n}\n\n.active_btn{\n  font-size: 1.1rem;\n}\n\n.submit_btn{\n  outline: 1px solid var(--primary_color);\n  outline-offset: 3px;\n  animation: submit_btn 0.5s infinite linear;\n}\n\n.iBtn{\n  color: var(--red);\n  font-size: 1rem;\n}\n\n.editLink {\n  cursor: pointer;\n  color: var(--primary_color);\n}\n\n.deleteButton {\n  cursor: pointer;\n  color: var(--red);\n}\n\n.crossIcon{\n  color: var(--gray);\n}\n\n.tickIcon{\n  color: var(--green);\n  font-size: 1.5rem;\n}\n\n\n.editLink:hover,\n.deleteButton:hover {\n  transform: scale(1.4); \n}\n\n\n/* .deleteButton:hover {\n  transform: scale(1.4); \n} */\n\n@keyframes submit_btn {\n  from{\n    outline-offset: 0px;\n  }\n  to{\n    outline-offset: 3px;\n\n  }\n}\n\n.disabled_btn{\n  padding: 0.4rem 2rem;\n  width: fit-content;\n  color: var(--gray) !important;\n  background-color: var(--light_gray);\n  border: 2px solid var(--light_gray);\n  outline: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  border-radius: var(--border_radius);\n  user-select: none;\n\n\n}\n.border{\n  height: 15rem;\n  width: 1rem;\n  background-color: black;\n  align-self: center;\n  border-radius: 5px;\n}\n\n.border_horizontal{\n  height: 1rem;\n  width: 15rem;\n  border-radius: 5px;\n  background-color: black;\n  align-self: center;\n}\n.borderless{\n  border: none !important;\n\n}\n.box_shadow{\n  box-shadow: var(--box_shadow);\n  padding: 1rem;\n}\n.button_container_flex{\n  display: flex;\n  align-items: center;\n  gap:1rem;\n}\n\n.blur_bg{\n  background: rgba(255, 255, 255, 0.2);\nborder-radius: 16px;\nbox-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\nbackdrop-filter: blur(5px);\n-webkit-backdrop-filter: blur(5px);\nborder: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.site_padding{\n  padding: 5rem;\n}\n/* flex classes */\n.flex_row_space_between{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n \n.flex_row_center{\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n.flex_row{\n  display: flex;\n}\n.flex_column{\n  display: flex;\n  flex-direction: column;\n}\n\n.flex_row_center_center{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex_column_center_center{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex_row_JustifyLeft_AlignCenter{\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n.flex_column_gap{\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.flex_row_gap{\n  display: flex;\n  gap: 1rem;\n}\n\n.flexWrap{\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.flexWrapChild{\n  width: 50%;\n  padding: 1rem;\n}\n\n\n.back_button{\n display: none;\n cursor: pointer;\n \n}\n.back_button_visible{\n  display: block;\n  font-size: 2rem;\n  position: absolute;\n  left: 5rem;\n  top: 10rem;\n  z-index: 2;\n  color: var(--black);\n  cursor: pointer;\n}\n.back_button_hidden{\n  display: none;\n\n}\n/* componenet common classes satrt here */\n\n/* spinner Animation */\n.spinnerAnimation{\n  -webkit-animation-name: spin;\n  -webkit-animation-duration: 400ms;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-name: spin;\n  -moz-animation-duration: 400ms;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n  -ms-animation-name: spin;\n  -ms-animation-duration: 400ms;\n  -ms-animation-iteration-count: infinite;\n  -ms-animation-timing-function: linear;\n  -o-transition: rotate(3600deg);\n}\n\n@-moz-keyframes spin {\n  from { -moz-transform: rotate(0deg); }\n  to { -moz-transform: rotate(360deg); }\n}\n@-webkit-keyframes spin {\n  from { -webkit-transform: rotate(0deg); }\n  to { -webkit-transform: rotate(360deg); }\n}\n@keyframes spin {\n  from {transform:rotate(0deg);}\n  to {transform:rotate(360deg);}\n}\n\n\n.RefreshData{\n  width: 12rem;\n}\n\n.dot{\n  width: 5px;\n  height: 5px;\n  min-width: 5px;\n  min-height: 5px;\n  border-radius: 50%;\n  background-color: var(--gray);\n}\n\n/* chart classes */\n.chart_row {\n  display: flex;\n  /* gap: 2rem; */\n  width: 100%;\n  gap: 2rem;\n\n}\n.chart_box {\n  position: relative;\n  height: 22rem;\n  box-shadow: var(--box_shadow);\n  border-radius: 15px;\n  padding: 1rem 2rem;\n  background-color: var(--db_Bg);\n  width: 50%;\n}\n\n\n.chart_row_with_cards{\n  position: relative;\n  display: flex;\n  /* height: 28rem; */\n  box-shadow: var(--box_shadow);\n  border-radius: 15px;\n  padding: 1rem 2rem;\n  background-color: var(--db_Bg);\n  width: 50%;\n}\n\n.chart_box_with_cards{\n  width: 65%;\n  /* height: 28rem; */\n}\n\n\n@media screen and (max-width: 1000px){\n\n  .chart_box {\n      position: relative;\n      width: 100% !important;\n  }\n\n  .chart_row {\n    flex-direction: column;\n}\n.chart_row_with_cards{\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n.chart_box_with_cards{\n  width: 100%;\n}\n}\n\n@media screen and (max-width: 950px){\n\n  h1 {\n      font-size: 4.5rem;\n      line-height: 1.2;\n  }\n  h2{\n    font-size: 2.65rem;\n   }\n  \n   h4{\n    font-size: 1.5rem;\n    line-height: 1.4;\n    text-transform: none;\n   }\n  h5{\n    font-style: normal;\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n  }\n  \n  \n  \n  .btn{\n    font-size: 0.875rem;\n    padding: 0.5rem 1rem;\n    border: 1px solid var(--primary_color);\n    font-weight: 500;\n    line-height: 1;\n  }\n\n  \n\n\n\n  .secondary_btn{\n    font-size: 0.875rem;\n    padding: 0.5rem 1rem;\n    border: 1px solid var(--primary_color);\n    font-weight: 500;\n    line-height: 1;\n  }\n    \n \n.tertiary_btn{\n  padding: 0.82rem 2.1rem;\n  font-size: 0.875rem;\n\n}\n\n  .site_padding{\n    padding: 4rem 2rem 2rem 2rem;\n  }\n  .border{\n    height: 0.2rem;\n    width: 15rem;\n  }\n  }\n\n@media screen and (max-width: 900px){\n  .back_button{\n    display: block;\n    font-size: 2rem;\n    position: absolute;\n    left: 20px;\n    top: 40px;\n    z-index: 2;\n    color: var(--black);\n  }\n  .back_button_visible{\n    display: block;\n    font-size: 2rem;\n    position: absolute;\n    left: 20px;\n    top: 40px;\n    z-index: 2;\n    color: var(--black);\n  }\n  \n}\n@media screen and (max-width: 350px){\n  .button_container_flex{\n    gap: 0.5rem;\n  }\n  \n.tertiary_btn{\n\npadding: 0.4rem 2rem;\n\n}\n}\n\n@media screen and (max-width: 350px){\n  .button_container_flex{\n  flex-direction: column;\n  }}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
